import { SUPPORT_ADA_REMOVE_CUSTOM_METAFIELD, SUPPORT_ADA_UPDATE_CUSTOM_METAFIELD } from './constants.js';
import { isNativeRegHeaderEnabled } from '~/components/app-bridge/app-properties.js';

const importAda = (botHandle, language, onReady, onChatToggled) => {
	if (window.adaEmbed) {
		if (typeof onReady === 'function') onReady();
	} else {
		window.adaSettings = {
			lazy: false,
			handle: botHandle,
			language,
			adaReadyCallback: () => {
				if (typeof onReady === 'function') onReady();
			},
			toggleCallback: isDrawerOpen => {
				const adaElement = document.querySelector('#ada-button-frame');
				if (!isDrawerOpen && adaElement) {
					adaElement.style.display = 'none';
				} else {
					adaElement.style.display = 'block';
				}
				if (typeof onChatToggled === 'function') onChatToggled(isDrawerOpen);
			}
		};

		const script = document.createElement('script');
		script.src = 'https://static.ada.support/embed2.js';
		script.type = 'text/javascript';
		script.id = '__ada';
		script.async = true;
		script.defer = true;
		document.getElementsByTagName('head')[0].appendChild(script);
	}
};

const openAdaChat = (bool, enableTopOffset) => {
	window.adaEmbed?.getInfo().then(info => {
		const { isChatOpen } = info;
		if (bool && !isChatOpen) {
			window.adaEmbed.toggle();
			if (enableTopOffset) {
				setTimeout(() => {
					const chatIframe = document.querySelector("#ada-entry > iframe[src*='/chat/']");
					chatIframe.style.height = isNativeRegHeaderEnabled()
						? '100%'
						: `calc(100% - var(--regulationHeight))`;
				}, 300);
			}
		} else if (!bool && isChatOpen) {
			window.adaEmbed.toggle();
		}
	});
};

const resetAda = (userData, resetChatHistory) => {
	const {
		authenticated,
		siteName,
		id,
		username,
		firstName,
		lastName,
		birth,
		email,
		locale,
		supportVIPTagCVValue,
		franchiseName,
		personalNumber
	} = userData;

	window.adaEmbed?.reset({
		metaFields: {
			isLoggedIn: !!authenticated,
			brandname: siteName || '',
			pid: id || '',
			username: username || '',
			firstname: firstName || '',
			lastname: lastName || '',
			dob: birth || '',
			email: email || '',
			cvValue: supportVIPTagCVValue || '',
			franchiseName: franchiseName || '',
			personalNumber: personalNumber || ''
		},
		language: locale?.slice(0, 2),
		resetChatHistory
	});
};

const setAdaLanguage = language => {
	window.adaEmbed.reset({
		language,
		resetChatHistory: false
	});
};

const updateAdaUser = userData => {
	const {
		authenticated,
		siteName,
		id,
		username,
		firstName,
		lastName,
		birth,
		email,
		supportVIPTagCVValue,
		locale,
		franchiseName,
		personalNumber,
		isPlayerOver24,
		customMetafields
	} = userData;

	window.adaEmbed?.setMetaFields({
		isLoggedIn: !!authenticated,
		brandname: siteName || '',
		pid: id || '',
		username: username || '',
		firstname: firstName || '',
		lastname: lastName || '',
		dob: birth || '',
		email: email || '',
		cvValue: supportVIPTagCVValue || '',
		franchiseName: franchiseName || '',
		personalNumber: personalNumber || '',
		isPlayerOver24,
		...customMetafields
	});

	const targetLanguageCode = locale.slice(0, 2);

	if (targetLanguageCode !== window.adaSettings?.language) {
		resetAda(userData, false);
		window.adaSettings.language = targetLanguageCode;
	}
};

const updateAdaCustomMetafield = (name, value) => {
	return {
		type: SUPPORT_ADA_UPDATE_CUSTOM_METAFIELD,
		payload: {
			name,
			value
		}
	};
};

/**
 * Creates an action to remove a custom metafield by name for ADA support.
 *
 * @param {string} name - The name of the custom metafield to remove.
 * @returns {Object} The action object for removing the custom metafield.
 */
const removeAdaCustomMetafield = name => {
	return {
		type: SUPPORT_ADA_REMOVE_CUSTOM_METAFIELD,
		payload: {
			name
		}
	};
};

export {
	importAda,
	openAdaChat,
	updateAdaUser,
	updateAdaCustomMetafield,
	removeAdaCustomMetafield,
	setAdaLanguage,
	resetAda
};
